// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.studentname {
  position: absolute;
  top: 85%;
  left: 43%;
}

.tutorname {
  position: absolute;
  top: 120%;
  left: 57%;
  font-size: 12px;
}

.tutorsignature {
  position: absolute;
  top: 120%;
  left: 29%;
}

@media screen and (max-width: 360px) {
  .studentname {
    position: absolute;
    top: 43%;
    left: 29%;
    font-size: 4px;
  }

  .tutorname {
    position: absolute;
    top: 52%;
    left: 56%;
    font-size: 4px;
    width: 180px;
  }

  .tutorsignature {
    position: absolute;
    top: 52%;
    left: 10%;
    font-size: 4px;
    width: 180px;
  }
}

@media (min-height: 690px) and (max-height: 729px) {
  .studentname {
    position: absolute;
    top: 47%;
    left: 32%;
    font-size: 4px;
  }

  .tutorname {
    position: absolute;
    top: 62%;
    left: 56%;
    font-size: 4px;
    width: 180px;
  }

  .tutorsignature {
    position: absolute;
    top: 62%;
    left: 14%;
    font-size: 4px;
    width: 180px;
  }
}

@media (min-height: 730px) and (max-height: 742px) {
  .studentname {
    position: absolute;
    top: 37%;
    left: 29%;
    font-size: 4px;
  }

  .tutorname {
    position: absolute;
    top: 46%;
    left: 56%;
    font-size: 4px;
    width: 180px;
  }

  .tutorsignature {
    position: absolute;
    top: 46%;
    left: 10%;
    font-size: 4px;
    width: 180px;
  }
}

@media (min-height: 490px) and (max-height: 629px) {
  .studentname {
    position: absolute;
    top: 45%;
    left: 28%;
    font-size: 4px;
  }

  .tutorname {
    position: absolute;
    top: 54%;
    left: 56%;
    font-size: 4px;
    width: 150px;
  }

  .tutorsignature {
    position: absolute;
    top: 54%;
    left: 9%;
    font-size: 4px;
    width: 180px;
  }
}

@media (min-width: 370px) and (max-width: 385px) {
  .studentname {
    position: absolute;
    top: 42%;
    left: 29%;
    font-size: 4px;
  }

  .tutorname {
    position: absolute;
    top: 52%;
    left: 56%;
    font-size: 4px;
    width: 180px;
  }

  .tutorsignature {
    position: absolute;
    top: 52%;
    left: 10%;
    font-size: 4px;
    width: 180px;
  }
}

@media (min-height: 880px) and (max-height: 900px) {
  .studentname {
    position: absolute;
    top: 32%;
    left: 29%;
    font-size: 4px;
  }

  .tutorname {
    position: absolute;
    top: 41%;
    left: 56%;
    font-size: 4px;
    width: 180px;
  }

  .tutorsignature {
    position: absolute;
    top: 41%;
    left: 10%;
    font-size: 4px;
    width: 180px;
  }
}

@media (min-height: 800px) and (max-height: 834px) {
  .studentname {
    position: absolute;
    top: 35%;
    left: 29%;
    font-size: 4px;
  }

  .tutorname {
    position: absolute;
    top: 43%;
    left: 56%;
    font-size: 4px;
    width: 180px;
  }

  .tutorsignature {
    position: absolute;
    top: 43%;
    left: 10%;
    font-size: 4px;
    width: 180px;
  }
}

@media (min-height: 842px) and (max-height: 849px) {
  .studentname {
    position: absolute;
    top: 33%;
    left: 29%;
    font-size: 4px;
  }

  .tutorname {
    position: absolute;
    top: 41%;
    left: 56%;
    font-size: 4px;
    width: 180px;
  }

  .tutorsignature {
    position: absolute;
    top: 41%;
    left: 10%;
    font-size: 4px;
    width: 180px;
  }
}

@media (min-height: 850px) and (max-height: 879px) {
  .studentname {
    position: absolute;
    top: 33%;
    left: 29%;
    font-size: 4px;
  }

  .tutorname {
    position: absolute;
    top: 41%;
    left: 56%;
    font-size: 4px;
    width: 180px;
  }

  .tutorsignature {
    position: absolute;
    top: 41%;
    left: 10%;
    font-size: 4px;
    width: 180px;
  }
}

@media (min-height: 901px) and (max-height: 980px) {
  .studentname {
    position: absolute;
    top: 32%;
    left: 29%;
    font-size: 4px;
  }

  .tutorname {
    position: absolute;
    top: 40%;
    left: 56%;
    font-size: 4px;
    width: 180px;
  }

  .tutorsignature {
    position: absolute;
    top: 40%;
    left: 10%;
    font-size: 4px;
    width: 180px;
  }
}

@media (min-height: 981px) and (max-height: 1100px) {
  .studentname {
    position: absolute;
    top: 39%;
    left: 36%;
    font-size: 4px;
  }

  .tutorname {
    position: absolute;
    top: 52%;
    left: 55%;
    font-size: 4px;
    width: 180px;
  }

  .tutorsignature {
    position: absolute;
    top: 52%;
    left: 22%;
    font-size: 4px;
    width: 180px;
  }
}

@media (min-height: 1101px) and (max-height: 1300px) {
  .studentname {
    position: absolute;
    top: 34%;
    left: 36%;
    font-size: 4px;
  }

  .tutorname {
    position: absolute;
    top: 46%;
    left: 57%;
    font-size: 4px;
    width: 180px;
  }

  .tutorsignature {
    position: absolute;
    top: 46%;
    left: 24%;
    font-size: 4px;
    width: 180px;
  }
}

@media (min-width: 1150px) and (max-width: 1300px) {
  .studentname {
    position: absolute;
    top: 67%;
    left: 42%;
    font-size: 4px;
  }

  .tutorname {
    position: absolute;
    top: 93%;
    left: 59%;
    font-size: 4px;
    width: 180px;
  }

  .tutorsignature {
    position: absolute;
    top: 94%;
    left: 30%;
    font-size: 4px;
    width: 180px;
  }
}

@media (min-width: 1000px) and (max-width: 1151px) {
  .studentname {
    position: absolute;
    top: 82%;
    left: 41%;
    font-size: 4px;
  }

  .tutorname {
    position: absolute;
    top: 109%;
    left: 57%;
    font-size: 4px;
    width: 180px;
  }

  .tutorsignature {
    position: absolute;
    top: 109%;
    left: 28%;
    font-size: 4px;
    width: 180px;
  }
}

@media (min-height: 1301px) and (max-height: 1363px) {
  .studentname {
    position: absolute;
    top: 29%;
    left: 38%;
    font-size: 4px;
  }

  .tutorname {
    position: absolute;
    top: 39%;
    left: 57%;
    font-size: 4px;
    width: 180px;
  }

  .tutorsignature {
    position: absolute;
    top: 39%;
    left: 24%;
    font-size: 4px;
    width: 180px;
  }
}

@media (min-height: 1364px) and (max-height: 1400px) {
  .studentname {
    position: absolute;
    top: 36%;
    left: 38%;
    font-size: 4px;
  }

  .tutorname {
    position: absolute;
    top: 49%;
    left: 57%;
    font-size: 4px;
    width: 180px;
  }

  .tutorsignature {
    position: absolute;
    top: 49%;
    left: 24%;
    font-size: 4px;
    width: 180px;
  }
}

/* 90% screen */
@media (min-width: 1400px) and (max-width: 1590px) {
  .studentname {
    position: absolute;
    top: 85%;
    left: 43%;
  }

  .tutorname {
    position: absolute;
    top: 122%;
    left: 57%;
  }

  .tutorsignature {
    position: absolute;
    top: 122%;
    left: 29%;
  }
}

/* 80% screen */
@media (min-width: 1600px) and (max-width: 1740px) {
  .studentname {
    position: absolute;
    top: 75%;
    left: 43%;
  }

  .tutorname {
    position: absolute;
    top: 108%;
    left: 56%;
  }

  .tutorsignature {
    position: absolute;
    top: 108%;
    left: 31%;
  }
}

/* 75% screen */
@media (min-width: 1790px) and (max-width: 1890px) {
  .studentname {
    position: absolute;
    top: 70%;
    left: 43%;
  }

  .tutorname {
    position: absolute;
    top: 102%;
    left: 56%;
  }

  .tutorsignature {
    position: absolute;
    top: 102%;
    left: 32%;
  }
}

/* 67% screen */
@media (min-width: 1900px) and (max-width: 3000px) {
  .studentname {
    position: absolute;
    top: 63%;
    left: 45%;
  }

  .tutorname {
    position: absolute;
    top: 90%;
    left: 56%;
  }

  .tutorsignature {
    position: absolute;
    top: 90%;
    left: 34%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Certificate.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;AACX;;AAEA;EACE;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;IACd,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;IACd,YAAY;EACd;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;IACd,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;IACd,YAAY;EACd;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;IACd,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;IACd,YAAY;EACd;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;IACd,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,cAAc;IACd,YAAY;EACd;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;IACd,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;IACd,YAAY;EACd;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;IACd,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;IACd,YAAY;EACd;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;IACd,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;IACd,YAAY;EACd;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;IACd,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;IACd,YAAY;EACd;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;IACd,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;IACd,YAAY;EACd;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;IACd,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;IACd,YAAY;EACd;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;IACd,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;IACd,YAAY;EACd;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;IACd,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;IACd,YAAY;EACd;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;IACd,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;IACd,YAAY;EACd;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,cAAc;IACd,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,cAAc;IACd,YAAY;EACd;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;IACd,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;IACd,YAAY;EACd;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;IACd,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;IACd,YAAY;EACd;AACF;;AAEA,eAAe;AACf;EACE;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,SAAS;EACX;AACF;;AAEA,eAAe;AACf;EACE;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,SAAS;EACX;AACF;;AAEA,eAAe;AACf;EACE;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,SAAS;EACX;AACF;;AAEA,eAAe;AACf;EACE;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;EACX;AACF","sourcesContent":[".studentname {\n  position: absolute;\n  top: 85%;\n  left: 43%;\n}\n\n.tutorname {\n  position: absolute;\n  top: 120%;\n  left: 57%;\n  font-size: 12px;\n}\n\n.tutorsignature {\n  position: absolute;\n  top: 120%;\n  left: 29%;\n}\n\n@media screen and (max-width: 360px) {\n  .studentname {\n    position: absolute;\n    top: 43%;\n    left: 29%;\n    font-size: 4px;\n  }\n\n  .tutorname {\n    position: absolute;\n    top: 52%;\n    left: 56%;\n    font-size: 4px;\n    width: 180px;\n  }\n\n  .tutorsignature {\n    position: absolute;\n    top: 52%;\n    left: 10%;\n    font-size: 4px;\n    width: 180px;\n  }\n}\n\n@media (min-height: 690px) and (max-height: 729px) {\n  .studentname {\n    position: absolute;\n    top: 47%;\n    left: 32%;\n    font-size: 4px;\n  }\n\n  .tutorname {\n    position: absolute;\n    top: 62%;\n    left: 56%;\n    font-size: 4px;\n    width: 180px;\n  }\n\n  .tutorsignature {\n    position: absolute;\n    top: 62%;\n    left: 14%;\n    font-size: 4px;\n    width: 180px;\n  }\n}\n\n@media (min-height: 730px) and (max-height: 742px) {\n  .studentname {\n    position: absolute;\n    top: 37%;\n    left: 29%;\n    font-size: 4px;\n  }\n\n  .tutorname {\n    position: absolute;\n    top: 46%;\n    left: 56%;\n    font-size: 4px;\n    width: 180px;\n  }\n\n  .tutorsignature {\n    position: absolute;\n    top: 46%;\n    left: 10%;\n    font-size: 4px;\n    width: 180px;\n  }\n}\n\n@media (min-height: 490px) and (max-height: 629px) {\n  .studentname {\n    position: absolute;\n    top: 45%;\n    left: 28%;\n    font-size: 4px;\n  }\n\n  .tutorname {\n    position: absolute;\n    top: 54%;\n    left: 56%;\n    font-size: 4px;\n    width: 150px;\n  }\n\n  .tutorsignature {\n    position: absolute;\n    top: 54%;\n    left: 9%;\n    font-size: 4px;\n    width: 180px;\n  }\n}\n\n@media (min-width: 370px) and (max-width: 385px) {\n  .studentname {\n    position: absolute;\n    top: 42%;\n    left: 29%;\n    font-size: 4px;\n  }\n\n  .tutorname {\n    position: absolute;\n    top: 52%;\n    left: 56%;\n    font-size: 4px;\n    width: 180px;\n  }\n\n  .tutorsignature {\n    position: absolute;\n    top: 52%;\n    left: 10%;\n    font-size: 4px;\n    width: 180px;\n  }\n}\n\n@media (min-height: 880px) and (max-height: 900px) {\n  .studentname {\n    position: absolute;\n    top: 32%;\n    left: 29%;\n    font-size: 4px;\n  }\n\n  .tutorname {\n    position: absolute;\n    top: 41%;\n    left: 56%;\n    font-size: 4px;\n    width: 180px;\n  }\n\n  .tutorsignature {\n    position: absolute;\n    top: 41%;\n    left: 10%;\n    font-size: 4px;\n    width: 180px;\n  }\n}\n\n@media (min-height: 800px) and (max-height: 834px) {\n  .studentname {\n    position: absolute;\n    top: 35%;\n    left: 29%;\n    font-size: 4px;\n  }\n\n  .tutorname {\n    position: absolute;\n    top: 43%;\n    left: 56%;\n    font-size: 4px;\n    width: 180px;\n  }\n\n  .tutorsignature {\n    position: absolute;\n    top: 43%;\n    left: 10%;\n    font-size: 4px;\n    width: 180px;\n  }\n}\n\n@media (min-height: 842px) and (max-height: 849px) {\n  .studentname {\n    position: absolute;\n    top: 33%;\n    left: 29%;\n    font-size: 4px;\n  }\n\n  .tutorname {\n    position: absolute;\n    top: 41%;\n    left: 56%;\n    font-size: 4px;\n    width: 180px;\n  }\n\n  .tutorsignature {\n    position: absolute;\n    top: 41%;\n    left: 10%;\n    font-size: 4px;\n    width: 180px;\n  }\n}\n\n@media (min-height: 850px) and (max-height: 879px) {\n  .studentname {\n    position: absolute;\n    top: 33%;\n    left: 29%;\n    font-size: 4px;\n  }\n\n  .tutorname {\n    position: absolute;\n    top: 41%;\n    left: 56%;\n    font-size: 4px;\n    width: 180px;\n  }\n\n  .tutorsignature {\n    position: absolute;\n    top: 41%;\n    left: 10%;\n    font-size: 4px;\n    width: 180px;\n  }\n}\n\n@media (min-height: 901px) and (max-height: 980px) {\n  .studentname {\n    position: absolute;\n    top: 32%;\n    left: 29%;\n    font-size: 4px;\n  }\n\n  .tutorname {\n    position: absolute;\n    top: 40%;\n    left: 56%;\n    font-size: 4px;\n    width: 180px;\n  }\n\n  .tutorsignature {\n    position: absolute;\n    top: 40%;\n    left: 10%;\n    font-size: 4px;\n    width: 180px;\n  }\n}\n\n@media (min-height: 981px) and (max-height: 1100px) {\n  .studentname {\n    position: absolute;\n    top: 39%;\n    left: 36%;\n    font-size: 4px;\n  }\n\n  .tutorname {\n    position: absolute;\n    top: 52%;\n    left: 55%;\n    font-size: 4px;\n    width: 180px;\n  }\n\n  .tutorsignature {\n    position: absolute;\n    top: 52%;\n    left: 22%;\n    font-size: 4px;\n    width: 180px;\n  }\n}\n\n@media (min-height: 1101px) and (max-height: 1300px) {\n  .studentname {\n    position: absolute;\n    top: 34%;\n    left: 36%;\n    font-size: 4px;\n  }\n\n  .tutorname {\n    position: absolute;\n    top: 46%;\n    left: 57%;\n    font-size: 4px;\n    width: 180px;\n  }\n\n  .tutorsignature {\n    position: absolute;\n    top: 46%;\n    left: 24%;\n    font-size: 4px;\n    width: 180px;\n  }\n}\n\n@media (min-width: 1150px) and (max-width: 1300px) {\n  .studentname {\n    position: absolute;\n    top: 67%;\n    left: 42%;\n    font-size: 4px;\n  }\n\n  .tutorname {\n    position: absolute;\n    top: 93%;\n    left: 59%;\n    font-size: 4px;\n    width: 180px;\n  }\n\n  .tutorsignature {\n    position: absolute;\n    top: 94%;\n    left: 30%;\n    font-size: 4px;\n    width: 180px;\n  }\n}\n\n@media (min-width: 1000px) and (max-width: 1151px) {\n  .studentname {\n    position: absolute;\n    top: 82%;\n    left: 41%;\n    font-size: 4px;\n  }\n\n  .tutorname {\n    position: absolute;\n    top: 109%;\n    left: 57%;\n    font-size: 4px;\n    width: 180px;\n  }\n\n  .tutorsignature {\n    position: absolute;\n    top: 109%;\n    left: 28%;\n    font-size: 4px;\n    width: 180px;\n  }\n}\n\n@media (min-height: 1301px) and (max-height: 1363px) {\n  .studentname {\n    position: absolute;\n    top: 29%;\n    left: 38%;\n    font-size: 4px;\n  }\n\n  .tutorname {\n    position: absolute;\n    top: 39%;\n    left: 57%;\n    font-size: 4px;\n    width: 180px;\n  }\n\n  .tutorsignature {\n    position: absolute;\n    top: 39%;\n    left: 24%;\n    font-size: 4px;\n    width: 180px;\n  }\n}\n\n@media (min-height: 1364px) and (max-height: 1400px) {\n  .studentname {\n    position: absolute;\n    top: 36%;\n    left: 38%;\n    font-size: 4px;\n  }\n\n  .tutorname {\n    position: absolute;\n    top: 49%;\n    left: 57%;\n    font-size: 4px;\n    width: 180px;\n  }\n\n  .tutorsignature {\n    position: absolute;\n    top: 49%;\n    left: 24%;\n    font-size: 4px;\n    width: 180px;\n  }\n}\n\n/* 90% screen */\n@media (min-width: 1400px) and (max-width: 1590px) {\n  .studentname {\n    position: absolute;\n    top: 85%;\n    left: 43%;\n  }\n\n  .tutorname {\n    position: absolute;\n    top: 122%;\n    left: 57%;\n  }\n\n  .tutorsignature {\n    position: absolute;\n    top: 122%;\n    left: 29%;\n  }\n}\n\n/* 80% screen */\n@media (min-width: 1600px) and (max-width: 1740px) {\n  .studentname {\n    position: absolute;\n    top: 75%;\n    left: 43%;\n  }\n\n  .tutorname {\n    position: absolute;\n    top: 108%;\n    left: 56%;\n  }\n\n  .tutorsignature {\n    position: absolute;\n    top: 108%;\n    left: 31%;\n  }\n}\n\n/* 75% screen */\n@media (min-width: 1790px) and (max-width: 1890px) {\n  .studentname {\n    position: absolute;\n    top: 70%;\n    left: 43%;\n  }\n\n  .tutorname {\n    position: absolute;\n    top: 102%;\n    left: 56%;\n  }\n\n  .tutorsignature {\n    position: absolute;\n    top: 102%;\n    left: 32%;\n  }\n}\n\n/* 67% screen */\n@media (min-width: 1900px) and (max-width: 3000px) {\n  .studentname {\n    position: absolute;\n    top: 63%;\n    left: 45%;\n  }\n\n  .tutorname {\n    position: absolute;\n    top: 90%;\n    left: 56%;\n  }\n\n  .tutorsignature {\n    position: absolute;\n    top: 90%;\n    left: 34%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
